"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OwnerSummary = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _selectors = require("../../../store/quote/selectors");
var _brandContext = require("../../../contextProviders/brandContext");
var _summaryKeyValuePair = require("../SummaryKeyValuePair/summaryKeyValuePair");
var _QuoteHeading = require("../../Layout/QuoteHeading");
var _steps = require("../../../constants/app/steps");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable react/forbid-prop-types */

var OwnerSummary = exports.OwnerSummary = function OwnerSummary() {
  var navigate = (0, _reactRouterDom.useNavigate)();
  var _useContext = (0, _react.useContext)(_brandContext.BrandContext),
    _useContext$activeBra = _useContext.activeBrandContext.steps,
    _useContext$activeBra2 = _useContext$activeBra.summary.ownerSummary,
    _useContext$activeBra3 = _useContext$activeBra2.heading,
    headingLabel = _useContext$activeBra3.label,
    panelIcon = _useContext$activeBra3.icon,
    allowEdit = _useContext$activeBra2.allowEdit,
    summaryLabels = _useContext$activeBra2.labels,
    StepDefinitions = _useContext$activeBra.StepDefinitions;
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.savedQuoteSelector),
    quote = _useSelector.quote;
  var owner = quote.owner;
  var titleName = owner.titleName,
    firstName = owner.firstName,
    surname = owner.surname;
  var handleEdit = function handleEdit() {
    navigate("/".concat(StepDefinitions.find(function (step) {
      return step.id === _steps.StepIndex.yourDetails;
    }).url));
  };
  var renderPanelIcon = function renderPanelIcon() {
    if (typeof panelIcon === 'function') {
      var icon = panelIcon(titleName);
      return icon;
    }
    return panelIcon;
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "summarySection ownerSummary"
  }, /*#__PURE__*/_react["default"].createElement(_QuoteHeading.QuoteToolHeading, {
    headingText: headingLabel,
    showMandatoryText: false,
    customCssClass: "sectionTitle"
  }), /*#__PURE__*/_react["default"].createElement("section", {
    className: "summaryPanel"
  }, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement("h3", null, renderPanelIcon(), " ", titleName, " ", firstName, " ", surname), allowEdit && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "button text_only",
    onClick: handleEdit
  }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: "pencil"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "labelText"
  }, "Edit"))), /*#__PURE__*/_react["default"].createElement("main", null, /*#__PURE__*/_react["default"].createElement(_summaryKeyValuePair.SummaryKeyValuePair, {
    key: "telephoneMobile",
    label: "Mobile",
    value: owner === null || owner === void 0 ? void 0 : owner.telephoneMobile
  }), /*#__PURE__*/_react["default"].createElement(_summaryKeyValuePair.SummaryKeyValuePair, {
    key: "email",
    label: "Email",
    value: owner === null || owner === void 0 ? void 0 : owner.email
  }), /*#__PURE__*/_react["default"].createElement(_summaryKeyValuePair.SummaryKeyValuePair, {
    key: "address",
    label: "Address",
    value: "".concat(owner.address, ", ").concat(owner.suburb, ", ").concat(owner.state, ", ").concat(owner.postcode)
  }))));
};